import { WIDGET_TYPE, WIDGET_VISIBILITY, WIDGET_TYPE_EDITABLE } from '../../../enums/widgets';
import { pathOr } from '../helpers';

export const linkToBanner = (widget = {}) => {
	const type = pathOr(null, ['type'])(widget);
	const items = pathOr([], ['items'])(widget);

	const number = items.filter((item) => item.is_visible).length;
	if (type === WIDGET_TYPE.highlight) {
		return number === 0 ? 'Add banner' : `${number} set(s)`;
	}

	return number === 0 ? 'Add banner' : `${number} banner(s)`;
};

export const linkToContentBlock = (widget = {}) => {
	const items = pathOr([], ['items'])(widget);
	const number = items.filter((item) => item.is_visible).length;

	return number === 0 ? 'Add content block' : `${number} content block(s)`;
};

export const linkToFlashSale = (widget = {}) => {
	return pathOr(null, ['items', 'name'])(widget);
};

export const linkToProductCategory = () => {
	return 'View category product banner';
};

export const linkToProducts = (widget = {}) => {
	const name = pathOr(null, ['items', '0', 'name_en'])(widget);

	return name || 'Add products';
};

export const transformedWidgetList = (widget = {}) => {
	const id = pathOr(null, ['id'])(widget);
	const name = pathOr(null, ['name'])(widget);
	const titleEN = pathOr(null, ['title_en'])(widget);
	const titleTH = pathOr(null, ['title_th'])(widget);
	const link = pathOr(null, ['link'])(widget);

	const type = pathOr(null, ['type'])(widget);
	const order = pathOr(null, ['order'])(widget);
	const websiteVisibility = WIDGET_VISIBILITY[!!pathOr(false, ['is_active'])(widget)];
	const mobileVisibility = WIDGET_VISIBILITY[!!pathOr(false, ['is_mobile_active'])(widget)];
	const data = pathOr([], ['items'])(widget);
	const sideToggleType = pathOr(null, ['side_toggle_type'])(widget);
	const contentTh = type === WIDGET_TYPE.wysiwyg ? pathOr(null, ['items', '0', 'content_th'])(widget) : null;
	const contentEn = type === WIDGET_TYPE.wysiwyg ? pathOr(null, ['items', '0', 'content_en'])(widget) : null;

	// Product widget
	const displayPriceType = pathOr(null, ['selling_type'])(widget);

	const buttonNameEN = pathOr(null, ['button_name_en'])(widget);
	const buttonNameTH = pathOr(null, ['button_name_th'])(widget);
	const widgetLink = pathOr(null, ['url_link'])(widget);
	const displayButton = Boolean(widget.is_display_button);
	const displayPage = pathOr(null, ['display_page'])(widget);

	let linkToName = '';
	let status = null;
	let categoryId = null;

	const normalBanners = [
		WIDGET_TYPE.hero,
		WIDGET_TYPE.custom_hero,
		WIDGET_TYPE.highlight,
		WIDGET_TYPE.small,
		WIDGET_TYPE.content,
		WIDGET_TYPE.shortcut,
		WIDGET_TYPE.shop_by_brand,
		WIDGET_TYPE.lob,
		WIDGET_TYPE.highlight_lob_banner,
	];

	if (normalBanners.includes(type)) {
		linkToName = linkToBanner(widget);
	} else if (type === WIDGET_TYPE.product_category) {
		linkToName = linkToProductCategory(widget);
	} else if (type === WIDGET_TYPE.flashSale) {
		linkToName = linkToFlashSale(widget);
		status = pathOr(null, ['items', 'period'])(widget);
	} else if (type === WIDGET_TYPE.products || type === WIDGET_TYPE.product) {
		linkToName = linkToProducts(widget);
		status = pathOr(null, ['items', '0', 'period_status'])(widget);
	} else if (type === WIDGET_TYPE.category) {
		categoryId = pathOr(null, ['items', 'category_id'])(widget);
	} else if (type === WIDGET_TYPE.highlightContentBlock) {
		linkToName = linkToContentBlock(widget);
	} else if (type === WIDGET_TYPE.stripeContentBlock) {
		linkToName = linkToContentBlock(widget);
	} else if (type === WIDGET_TYPE.textWithImageContentBlock) {
		linkToName = linkToContentBlock(widget);
	} else if (type === WIDGET_TYPE.wysiwyg) {
		linkToName = contentEn ? 'Edit Widget' : 'Add Widget';
	}

	const linkTo = {
		id,
		name: linkToName,
		status,
		type,
		data,
	};

	const editable = WIDGET_TYPE_EDITABLE.includes(type);

	const edit = {
		id,
		editable,
	};

	const isActive = pathOr(false, ['is_active'])(widget) ? 1 : 0;
	const isMobileActive = pathOr(false, ['is_mobile_active'])(widget) ? 1 : 0;

	return {
		id,
		name,
		titleEN,
		titleTH,
		link,
		type,
		order,
		isActive,
		isMobileActive,
		websiteVisibility,
		mobileVisibility,
		linkTo,
		edit,
		editable,
		data,
		categoryId,
		sideToggleType,
		displayPriceType,
		contentTh,
		contentEn,
		buttonNameEN,
		buttonNameTH,
		widgetLink,
		displayButton,
		displayPage,
	};
};
